const { default: visibleTypes } = require("./visibleTypes");

const grades = {
    "1": {
        name: "גן גיל 3",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
            [visibleTypes.MULTIPLE_CHOICE]: 60,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        lineHeight: 1.6,
        columnCount: 3,
        rowCount: 3,
        columnGap: 65
    },
    "2": {
        name: "גן גיל 4",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
            [visibleTypes.MULTIPLE_CHOICE]: 60,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 3,
        lineHeight: 1.6,
        rowCount: 3,
        columnGap: 65
    },
    "3": {
        name: "גן חובה",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
            [visibleTypes.MULTIPLE_CHOICE]: 60,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 3,
        rowCount: 3,
        columnGap: 65,
        lineHeight: 1.6,
    },
    "4": {
        name: "כתה א",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 70,
            [visibleTypes.MULTIPLE_CHOICE]: 60,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 3,
        rowCount: 3,
        columnGap: 65,
        lineHeight: 1.6,
    },
    "5": {
        name: "כתה ב",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 50,
            [visibleTypes.WORD_GROUP]: 60,
            [visibleTypes.MULTIPLE_CHOICE]: 50,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 3,
        rowCount: 3,
        columnGap: 65,
        lineHeight: 1.6,
    },
    "6": {
        name: "כתה ג",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 40,
            [visibleTypes.WORD_GROUP]: 50,
            [visibleTypes.MULTIPLE_CHOICE]: 50,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 110,
        cardWidth: 230,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 3,
        rowCount: 3,
        columnGap: 65,
        lineHeight: 1.6,
    },
    "7": {
        name: "כתה ד",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 40,
            [visibleTypes.WORD_GROUP]: 40,
            [visibleTypes.MULTIPLE_CHOICE]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 82,
        cardWidth: 220,
        imageWidth: 128,
        imageHeight: 128,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
    },
    "8": {
        name: "כתה ה",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 35,
            [visibleTypes.WORD_GROUP]: 35,
            [visibleTypes.MULTIPLE_CHOICE]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 82,
        cardWidth: 220,
        imageWidth: 80,
        imageHeight: 80,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
    },
    "9": {
        name: "כתה ו",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        imageWidth: 75,
        imageHeight: 75,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
        font: "Calibri"
    },
    "10": {
        name: "כתה ז",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        imageWidth: 75,
        imageHeight: 75,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
        font: "Calibri"

    },
    "11": {
        name: "כתה ח",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30,
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
        font: "Calibri"

    },
    "12": {
        name: "כתה ט",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        imageWidth: 75,
        imageHeight: 75,
        columnCount: 5,
        rowCount: 4,
        lineHeight: 1.3,
        columnGap: 35,
        font: "Calibri"

        
    },
    "13": {
        name: "כתה י",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        imageWidth: 75,
        imageHeight: 75,
        columnCount: 5,
        rowCount: 4,
        lineHeight: 1.3,
        columnGap: 35
    },
    "14": {
        name: "כתה יא",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        columnCount: 5,
        rowCount: 4,
        lineHeight: 1.3,
        columnGap: 35,
        font: "Calibri"

    },
    "15": {
        name: "כתה יב",
        fontsize: {
            [visibleTypes.PARAGRAPH]: 30,
            [visibleTypes.WORD_GROUP]: 30,
            [visibleTypes.MULTIPLE_CHOICE]: 30
        },
        // fontfamily:"",
        vowel: true,
        cardHeight: 72,
        cardWidth: 220,
        columnCount: 5,
        rowCount: 4,
        columnGap: 35,
        lineHeight: 1.3,
        font: "Calibri"

    }
}

export default grades
